export default __webpack_public_path__ + "static/media/reggesteyn.9cba6c2c.svg";